<template>
  <v-img :src="imageUrl" :max-height="smallSize ? 72 : 300" :max-width="smallSize ? 65 : 400" contain></v-img>
</template>

<script>
export default {
  props: {
    smallSize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageUrl() {
      const baseUrl = window.location.origin;
      if (baseUrl == "https://silverstream.reshub.ie") {
        return "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/whitelabelLogin%2FSilverstream_logo.png?alt=media&token=9f322cd8-004e-4c4e-bbee-908cf3046afb";
      } else if (baseUrl == "http://silverstream.reshub.ie") {
        return "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/whitelabelLogin%2FSilverstream_logo.png?alt=media&token=9f322cd8-004e-4c4e-bbee-908cf3046afb";
      } else if (
          baseUrl == "https://vacenti.web.app" ||
          baseUrl == "http://vacenti.web.app" ||
          baseUrl == "http://staff.vacenti.com.au" ||
          baseUrl == "https://staff.vacenti.com.au"
      ) {
        return "https://firebasestorage.googleapis.com/v0/b/reshub-aus-vacenti.appspot.com/o/brandSettings%2FVacenti_Stacked_Pos_RGB.png?alt=media&token=279abd34-9bea-473c-8e3d-b05ccad2c3f1";
      } else if (
          baseUrl == "https://virtue.web.app" ||
          baseUrl == "http://virtue.web.app"
      ) {
        return "https://www.virtue.ie/wp-content/uploads/2018/06/Virtue-Logo_RGB-180x110.png";
      } else {
        return "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/whitelabelLogin%2FreshubLogo%2Freshub.png?alt=media&token=b7bb8c91-b93b-4385-a5d1-8a211d1b1b9f";
      }
    }
  }
};
</script>

<style></style>
